import { Moon, Sun, Laptop, Pill } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme } from "./providers/ThemeProvider";
import { COMMON } from '@/lib/test/test-ids';
import { useLocalStorageContext } from "@/contexts/LocalStorageContext";
import { useTranslation } from 'react-i18next';
import i18n from '@/lib/i18n';

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation();

  const handleThemeChange = (newTheme: 'light' | 'dark' | 'pharmacy' | 'system') => {
    setTheme(newTheme);
    // Force update i18n to render when theme changes
    i18n.reloadResources();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" data-testid={COMMON.SIDEBAR.THEME_SWITCHER}>
          <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
          <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
          <Pill className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all pharmacy:rotate-0 pharmacy:scale-100" />
          <span className="sr-only">{t('common.theme_toggle', 'Toggle theme')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-full">
        <DropdownMenuItem onClick={() => handleThemeChange("light")} data-testid="theme-light-option">
          <Sun className="mr-2 h-4 w-4" />
          {t('common.theme_light', 'Light')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleThemeChange("dark")} data-testid="theme-dark-option">
          <Moon className="mr-2 h-4 w-4" />
          {t('common.theme_dark', 'Dark')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleThemeChange("pharmacy")} data-testid="theme-pharmacy-option">
          <Pill className="mr-2 h-4 w-4" />
          {t('common.theme_pharmacy', 'Pharmacy')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleThemeChange("system")} data-testid="theme-system-option">
          <Laptop className="mr-2 h-4 w-4" />
          {t('common.theme_system', 'System')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}